import * as React from 'react';
import IntersectionObserver from 'react-intersection-observer';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section, NOOP} from 'components/UIKit';
import {ListingExpense as ListingExpenseType} from '../../types';
import styles from './ListingExpenses.scss';
import {ListingExpense} from './components/ListingExpense';
import * as locales from './locales';

export interface ListingExpensesProps {
  id?: string;
  expenses: ListingExpenseType[];
  onVisibilityChange?: any;
}

class ListingExpensesComponent extends React.Component<ListingExpensesProps & WithI18nProps> {
  handleViewportChange = (inView) => {
    const {onVisibilityChange = NOOP, id} = this.props;

    onVisibilityChange(id, inView);
  };

  render() {
    const {id, i18n, expenses} = this.props;

    return (
      <IntersectionObserver threshold={0.3} rootMargin="-72px" onChange={this.handleViewportChange}>
        <Section
          id={id}
          spacing="medium"
          heading={i18n.translate('expenses')}
          headingProps={{type: 'h5', component: 'h2'}}
          fullWidth
        >
          <ul className={styles.List}>
            {expenses.map((expense) => (
              <ListingExpense key={expense.title} expense={expense} />
            ))}
          </ul>
        </Section>
      </IntersectionObserver>
    );
  }
}

export const ListingExpenses = withI18n({
  id: 'ListingExpenses',
  fallback: locales.en,
})(ListingExpensesComponent);

export default ListingExpenses;
